import './scss/index.scss';

import ComponentsFactory from 'foundation/components-factory';
import QualifiedPlayerCardComponent from './js/qualified-player-card.component';

ComponentsFactory.getInstance().define('qualified-player-card', QualifiedPlayerCardComponent);
